import { usePostRest } from 'common/hooks';
import { ApiPaths } from '../constants/apiPaths';
import Yup from 'utils/validation';

export const requestBookingRescheduleSchema = Yup.object({
  conversationId: Yup.string().required()
});

export type APIBookingRescheduleSchema = Yup.InferType<
  typeof requestBookingRescheduleSchema
>;

export const useRequestBookingReschedule = () =>
  usePostRest<void, APIBookingRescheduleSchema>(
    ApiPaths.REQUEST_BOOKING_RESCHEDULE
  );
